export const getProgressDefault = () => ({
  finish: 0,
  inProgress: 0,
  pending: 0,
})

export const formatPercentage = (val: number, total: number) =>
  +((val / total) * 100).toFixed(1)

interface Progress {
  finish: number
  inProgress: number
  pending: number
}

export function reduceProgress<P extends Progress>(
  coursesProgress: P[]
): Progress {
  return (coursesProgress || []).reduce((acc, val) => {
    acc.finish += val.finish
    acc.inProgress += val.inProgress
    acc.pending += val.pending
    return acc
  }, getProgressDefault())
}

export function getProgressPercentage<P extends Progress>(
  coursesProgress: P[]
): Progress {
  const { finish, inProgress, pending } = reduceProgress(coursesProgress)

  const totalPercent = finish + inProgress + pending || 1
  const format = (percent: number) => formatPercentage(percent, totalPercent)
  return {
    finish: format(finish),
    inProgress: format(inProgress),
    pending: format(pending),
  }
}

/** Clasifica cada curso por estado dominante (una fila por curso en coursesProgress). */
export function countCoursesByDominantState<P extends Progress>(
  coursesProgress: P[]
): Progress {
  return (coursesProgress || []).reduce((acc, val) => {
    if (val.pending > 0) {
      acc.pending += 1
      return acc
    }
    if (val.inProgress > 0) {
      acc.inProgress += 1
      return acc
    }
    acc.finish += 1
    return acc
  }, getProgressDefault())
}

export function resolveProgressBars(input: {
  coursesProgress?: Progress[]
  participantsAdvance?: Progress
  coursesAdvance?: Progress
}): { participants: Progress; courses: Progress } {
  const participants = getProgressPercentage(
    input.participantsAdvance
      ? [input.participantsAdvance]
      : input.coursesProgress || []
  )
  const courses = getProgressPercentage([
    input.coursesAdvance ||
      countCoursesByDominantState(input.coursesProgress || []),
  ])

  return { participants, courses }
}
